import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getProductsUsage } from 'a/selectors/usageSelectors';
import { setProduct } from 'a/actions/appSessionActions';
import { showLoadingPercentage } from 'root/lib/utilityFunctions';
import { reportUserSettingsChanged } from 'a/hub/actions/metagameSearchlight';
import {
  PRODUCT_READING,
  PRODUCT_LECTURA,
  SELECTED_PRODUCT_KEY,
} from 'root/lib/constants';

import {
  Banner,
  ButtonsContainer,
  Container,
  ContinueButton,
  Label,
  LecturaButton,
  LecturaIcon,
  PopupBackground,
  ReadingButton,
  ReadingIcon,
  IconWrapper,
  UsageTime,
} from './productSelectionStyles';

const ProductSelectScreen = ({ onProductSelection }) => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState('');

  const usageData = useSelector(getProductsUsage);

  useEffect(() => {
    window.reactLoaded();
  }, []);

  const callback = () => {
    // after selecting product and clicking Go, display loading percentage for final APIs
    showLoadingPercentage();
    sessionStorage.setItem(SELECTED_PRODUCT_KEY, selectedProduct);

    dispatch(setProduct(selectedProduct));
    dispatch(reportUserSettingsChanged({ key: 'product', value: selectedProduct }));
    onProductSelection(selectedProduct);
  };

  const getUsageDescription = (time) => {
    const unit = time === 1 ? 'minute' : 'minutes';
    return `Weekly usage is ${time} ${unit}.`;
  };

  const showUsage = !!usageData;
  const isLecturaSelected = selectedProduct === PRODUCT_LECTURA;
  const isReadingSelected = selectedProduct === PRODUCT_READING;
  const goText = isLecturaSelected ? '¡Vamos!' : 'Go!';

  return (
    <Container data-dd-action-name="product-select">
      <Banner />
      <PopupBackground>
        <ButtonsContainer>
          <ReadingButton
            data-testid="reading-button"
            data-dd-action-name="product-select:reading"
            selected={isReadingSelected}
            onClick={() => setSelectedProduct(PRODUCT_READING)}
          >
            <IconWrapper><ReadingIcon /></IconWrapper>
            <Label selected={isReadingSelected} backgroundColor="#4086CA">
              <span>Reading</span>
              {showUsage && (
                <UsageTime>
                  <span aria-hidden="true">{usageData.reading} min</span>
                  <span className="sr-only">{getUsageDescription(usageData.reading)}</span>
                </UsageTime>
              )}
            </Label>
          </ReadingButton>
          <LecturaButton
            data-testid="lectura-button"
            data-dd-action-name="product-select:lectura"
            selected={isLecturaSelected}
            onClick={() => setSelectedProduct(PRODUCT_LECTURA)}
          >
            <IconWrapper><LecturaIcon /></IconWrapper>
            <Label selected={isLecturaSelected} backgroundColor="#E9784D">
              <span>Lectura</span>
              {showUsage && (
                <UsageTime>
                  <span aria-hidden="true">{usageData.lectura} min</span>
                  <span className="sr-only">{getUsageDescription(usageData.lectura)}</span>
                </UsageTime>
              )}
            </Label>
          </LecturaButton>
        </ButtonsContainer>
        {selectedProduct && (
          <ContinueButton
            data-testid="continue-button"
            data-dd-action-name="product-select:continue"
            colorSet="indigo"
            icon="play_right"
            onClick={callback}
            isLecturaSelected={isLecturaSelected}
          >
            {goText}
          </ContinueButton>
        )}
      </PopupBackground>
    </Container>
  );
};

ProductSelectScreen.propTypes = {
  onProductSelection: PropTypes.func.isRequired,
};

export default ProductSelectScreen;
